/**
 * androidBridge.js — glue between the web app and the Sakthi CRM Android
 * WebView. On native the WebView injects `window.SakthiBridge`; on plain
 * browsers this file is a no-op.
 *
 *   • Detects the native shell via `window.SakthiBridge`.
 *   • After login, reads the FCM token from the bridge and POSTs it to
 *     `/api/push/register` with the current JWT so subsequent server-side
 *     pushes reach this device.
 *   • Safe to call multiple times — same token → server dedupes via $addToSet.
 */
import api from "@/lib/api";

const HAS_BRIDGE = typeof window !== "undefined" && window.SakthiBridge && typeof window.SakthiBridge.getFcmToken === "function";

export const isNativeAndroid = () => HAS_BRIDGE;

export async function registerFcmTokenIfNative() {
  if (!HAS_BRIDGE) return { ok: false, reason: "not-native" };
  try {
    const token = window.SakthiBridge.getFcmToken();
    if (!token) return { ok: false, reason: "no-token-yet" };
    // /api/push/register uses the auth interceptor — assumes user is logged in
    const r = await api.post("/push/register", { token, platform: "android" });
    return r.data;
  } catch (e) {
    return { ok: false, reason: "post-failed", error: String(e) };
  }
}
